let comingSoonIds = {
    coming_soon_in_label                :   "Segera Hadir di ",
    keep_lookout_for_continue_label     :   "Terus mencari Solusi Fotografi berkemampuan AI pertama di industri",
    watch_the_space_more_label          :   "PERHATIKAN RUANG INI UNTUK LEBIH BANYAK",
    
}

export default {
    ...comingSoonIds
}